import React from "react";
import TransportationServiceSetupSummaryContainer from "../../containers/ProfileContainer/TransportationServiceSetupSummaryContainer";

const TransportationServiceSetupSummaryPage = () => {
  return <TransportationServiceSetupSummaryContainer />;
};

export default TransportationServiceSetupSummaryPage;
